import React from 'react';
import Logo from '../assets/logo-sv.png';
import './LoadingState.css';

function LoadingState({ message = "Processing...", submessage = null }) {
  return (
    <div className="loading-state">
      <div className="loading-content">
        {/* Option 1: Simple animated logo */}
        <img src={Logo} alt="Logo" className="loading-logo" />
        
        {/* Option 2: Logo with spinning ring (uncomment to use) */}
        {/* 
        <div className="loading-logo-wrapper">
          <img src={Logo} alt="Logo" className="loading-logo" />
        </div>
        */}
        
        <div className="loading-text">
          <h3>{message}</h3>
          {submessage && <p>{submessage}</p>}
        </div>
      </div>
    </div>
  );
}

export default LoadingState;